// Sprzedawcy wersji krajowych (decyzja 2026-10-07: dane kraju w osobnym schemacie bazy).
//
// Klucz = nazwa sprzedawcy w bazie (transform-svc/config/general/sellers.json),
// wartość = etykieta w filtrze. Sufiks " RO" jest tylko w bazie: sellers.json jest jeden
// dla wszystkich krajów, więc nazwa musi się różnić od polskich sklepów.
//
// Polska nadal korzysta z list w filtersSchema.js (panelSellers, inverterSellers,
// magazineSellers). Wersja rumuńska weźmie listy stąd przez sprzedawcyDlaKraju().

import { panelSellers, inverterSellers, magazineSellers } from './filtersSchema'

const SPRZEDAWCY_RO = {
  panele: {
    'Anfi Power RO': 'Anfi Power',
    'Atlantico RO': 'Atlantico',
    'Baterii Shop RO': 'Baterii Shop',
    'Bruma RO': 'Bruma',
    'e-Panouri RO': 'e-Panouri',
    'eCharged RO': 'eCharged',
    'EcoSolaris RO': 'EcoSolaris',
    'ElectricUP RO': 'ElectricUP',
    'Fabrica de Baterii RO': 'Fabrica de Baterii',
    'Genway RO': 'Genway',
    'Giaul RO': 'Giaul',
    'Nectaria RO': 'Nectaria',
    'Solar1000 RO': 'Solar1000',
    'Soleo Energy RO': 'Soleo Energy',
    'SunX RO': 'SunX',
    'Trevora RO': 'Trevora',
    'V-TAC Energy RO': 'V-TAC Energy',
    'Voltora RO': 'Voltora',
    'WattRo Energy RO': 'WattRo Energy',
  },
  inwerter: {
    'Anfi Power RO': 'Anfi Power',
    'Atlantico RO': 'Atlantico',
    'Baterii Shop RO': 'Baterii Shop',
    'Bruma RO': 'Bruma',
    'BYD Battery RO': 'BYD Battery',
    'e-Panouri RO': 'e-Panouri',
    'eCharged RO': 'eCharged',
    'EcoSolaris RO': 'EcoSolaris',
    'ElectricUP RO': 'ElectricUP',
    'Fabrica de Baterii RO': 'Fabrica de Baterii',
    'Genway RO': 'Genway',
    'Giaul RO': 'Giaul',
    'Nectaria RO': 'Nectaria',
    'Pedavo RO': 'Pedavo',
    'Shop Sigenergy RO': 'Shop Sigenergy',
    'Solar1000 RO': 'Solar1000',
    'Solartech RO': 'Solartech',
    'SunX RO': 'SunX',
    'Trevora RO': 'Trevora',
    'V-TAC Energy RO': 'V-TAC Energy',
    'Voltora RO': 'Voltora',
    'WattRo Energy RO': 'WattRo Energy',
  },
  magazyn: {
    'Anfi Power RO': 'Anfi Power',
    'Atlantico RO': 'Atlantico',
    'Baterii Shop RO': 'Baterii Shop',
    'Bruma RO': 'Bruma',
    'BYD Battery RO': 'BYD Battery',
    'e-Panouri RO': 'e-Panouri',
    'eCharged RO': 'eCharged',
    'EcoSolaris RO': 'EcoSolaris',
    'ElectricUP RO': 'ElectricUP',
    'Fabrica de Baterii RO': 'Fabrica de Baterii',
    'Genway RO': 'Genway',
    'Giaul RO': 'Giaul',
    'Kiwi Solar RO': 'Kiwi Solar',
    'Nectaria RO': 'Nectaria',
    'Pedavo RO': 'Pedavo',
    'Shop Sigenergy RO': 'Shop Sigenergy',
    'Solar1000 RO': 'Solar1000',
    'Solartech RO': 'Solartech',
    'SunX RO': 'SunX',
    'Trevora RO': 'Trevora',
    'V-TAC Energy RO': 'V-TAC Energy',
    'Voltora RO': 'Voltora',
    'WattRo Energy RO': 'WattRo Energy',
  },
}

const SPRZEDAWCY_PL = {
  panele: panelSellers,
  inwerter: inverterSellers,
  magazyn: magazineSellers,
}

const SPRZEDAWCY = { pl: SPRZEDAWCY_PL, ro: SPRZEDAWCY_RO }

// productType jak w Filters.jsx: 'inwerter', 'magazyn', inaczej panele.
export function sprzedawcyDlaKraju(productType, kraj = 'pl') {
  const listy = SPRZEDAWCY[kraj] || SPRZEDAWCY_PL
  if (productType === 'inwerter') return listy.inwerter
  if (productType === 'magazyn') return listy.magazyn
  return listy.panele
}
